import { QueryKey, useQuery, QueryResult, QueryConfig } from "react-query";
import { AxiosRequestConfig } from "axios";
import api from "../index";
import { ICreditResponse } from "types/payments/Credit";

export const getTeamCredits = async (
  teamId: number,
  options?: AxiosRequestConfig,
): Promise<ICreditResponse> => {
  const { data } = await api.get<ICreditResponse>(
    `/payments/teams/${teamId}/credits`,
    options,
  );
  return data;
};

export const getTeamCreditsQueryKey = (teamId: number) => [
  `payments/teams/${teamId}/credits`,
];

export const useTeamCredits = (
  teamId: number,
  options?: {
    query?: QueryConfig<ICreditResponse, void>;
    request?: AxiosRequestConfig;
  },
): QueryResult<ICreditResponse, void> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options || {};
  const queryKey = queryOptions?.queryKey ?? getTeamCreditsQueryKey(teamId);

  const queryFn = () => getTeamCredits(teamId, requestOptions);

  const query = useQuery(queryKey, queryFn, {
    ...queryOptions,
  });

  return {
    queryKey,
    ...query,
  };
};
